export const copyRenderedElementToClipboard = async (element: HTMLElement | null): Promise<boolean> => {
  if (!element) {
    return false
  }

  const clipboard = navigator.clipboard
  if (!clipboard) {
    return false
  }

  const text = element.innerText
  const html = element.innerHTML

  try {
    if ('write' in clipboard && typeof ClipboardItem !== 'undefined') {
      await clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([text], { type: 'text/plain' }),
          'text/html': new Blob([html], { type: 'text/html' }),
        }),
      ])
      return true
    }
  } catch {
    // ignore and fallback
  }

  try {
    if ('writeText' in clipboard) {
      await clipboard.writeText(text)
      return true
    }
  } catch {
    return false
  }

  return false
}
